<ng-container *ngIf="article">
  <div>
    {{ article.location }}{{ article.location ? ', ' : '' }}{{ article.displayDate | localizedDate : 'longDate' }}
  </div>
  <div class="article-headline">{{ article.title }}</div>
  <ng-container *ngIf="showMetaItems">
    <mb-meta-items [metaItems]="article.metaItems" itemClass="btn btn-plain"></mb-meta-items>
  </ng-container>
</ng-container>
